module.exports = __webpack_public_path__ + "static/media/CardholderHover.b1de8b90.svg";